import { useState } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { File01Icon } from '@hugeicons/core-free-icons'
import { useTemplates } from '../templates.hooks'
import type { MessageChannel, MessageTemplate } from '../templates.types'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

// Selector de plantilla para los composers. No renderiza nada si la sucursal
// todavía no tiene plantillas activas de ese canal.
export function TemplatePicker({
  channel,
  onSelect,
}: {
  channel: MessageChannel
  onSelect: (template: MessageTemplate) => void
}) {
  const { data: templates = [] } = useTemplates(channel, true)
  const [selectedId, setSelectedId] = useState('')

  if (templates.length === 0) return null

  return (
    <Select
      value={selectedId}
      onValueChange={(id) => {
        setSelectedId(id)
        const template = templates.find((option) => option.id === id)
        if (template) onSelect(template)
      }}
    >
      <SelectTrigger size="sm" className="max-w-52 text-xs">
        <HugeiconsIcon icon={File01Icon} className="size-3.5 text-muted-foreground" />
        <SelectValue placeholder="Usar plantilla" />
      </SelectTrigger>
      <SelectContent align="end">
        {templates.map((template) => (
          <SelectItem key={template.id} value={template.id}>
            {template.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
